import {t} from 'i18next';
import {InputText} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import {CriteriaTextComponent} from '../components/criteria/CriteriaTextComponent';
import SettingModel from '../model/SettingModel';
import EnumService from '../services/EnumService';
import SettingService from '../services/SettingService';
import StringUtils from '../utils/StringUtils';
import SettingDialog from './SettingDialog';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class SettingListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new SettingService());
        this.service = new SettingService();
        this.enumService = new EnumService();
        this.state = {
            list: [],
            loading: true,
            criteria: this.getCleanSearchCriteria(),
            settingGroupTypeOptions: [],
        };
        this.handleOpenNewDialog = this.handleOpenNewDialog.bind(this);
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.onRowEditComplete = this.onRowEditComplete.bind(this);
        this.parameterEditor = this.parameterEditor.bind(this);
    }

    updateSearchCriteria(criteria) {
        return {
            locale: criteria?.locale,
            name: criteria.name?.enumValue,
            setting_group: criteria.settingGroup,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        };
    }
    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            name: '',
            settingGroup: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }
    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'setting.listTitle';
    }
    getCriteriaName() {
        return 'setting-list-sc';
    }

    getContainerListName() {
        return 'setting-list-container';
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    label={t('setting.name')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    placeholder={t('setting.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaDropdownComponent
                    id='groupTypeSc'
                    name='settingGroup'
                    showClear
                    label={t('setting.type')}
                    value={this.state.criteria.settingGroup}
                    options={this.state.settingGroupTypeOptions}
                    placeholder={t('setting.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    filter
                />
            </div>
        );
    }

    parameterEditor(options) {
        return (
            <div>
                <InputText
                    type='text'
                    value={options.value}
                    onChange={(e) => {
                        options.editorCallback(e.target.value);
                    }}
                />
                {StringUtils.isBlank(options.value) ? (
                    <small id='username2-help' className='p-error block'>
                        {t('list.emptyField')}
                    </small>
                ) : null}
            </div>
        );
    }

    onRowEditComplete(e) {
        if (!e.newData.value || StringUtils.isBlank(e.newData.value)) {
            this.showErrorMessage(t('list.emptyField'));
            return;
        }

        this.service
            .update({id: e.data.id, value: e.newData.value})
            .then(() => {
                this.showSuccessMessage(t('setting.paramEdited'));
                this.refreshTable();
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
            });
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {field: 'name', header: t('setting.name'), sortable: true},
            {
                field: 'value',
                editor: (options) => this.parameterEditor(options),
                header: t('setting.value'),
                sortable: true,
            },
            {
                key: 'actions',
                header: t('setting.details'),
                rowEditor: true,
                className: 'table-column-action',
            },
        ];
    }

    handleOpenDialog(rowData) {
        this.setState({
            dialogVisibile: true,
            element: rowData,
            dialogViewMode: 'EDIT',
        });
    }
    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('ApplicationSettingGroup')
            .then((settingGroupTypeOptions) => {
                this.setState({
                    settingGroupTypeOptions,
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    handleOpenNewDialog() {
        this.setState({
            dialogVisibile: true,
            element: new SettingModel(),
            dialogViewMode: 'NEW',
        });
    }
    handleCloseDialog() {
        this.setState({
            dialogVisibile: false,
            element: undefined,
        });
    }

    updateElement(data) {
        this.setState(
            {
                element: {
                    name: data.name,
                    value: data.value,
                    id: data.id,
                    version: data.version,
                },
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    breadCrumbItems() {
        return [{name: t('setting.listName'), url: '/setting-list'}];
    }
    render() {
        return (
            <div className='container-fluid'>
                {this.state.dialogVisibile ? (
                    <SettingDialog
                        key={`setting-dialog-${this.state.element?.id}`}
                        elementId={this.state.element?.id}
                        onHide={this.handleCloseDialog}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                                this.unblockUi();
                            })
                        }
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                {this.renderView()}
            </div>
        );
    }
}

SettingListContainer.defaultProps = {
    detailUrl: '/setting/details',
    newUrl: '/setting/create',
    backUrl: '',
    lazy: true,
    disablePointerFromList: true,
};

SettingListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    backUrl: PropTypes.string,
    disablePointerFromList: PropTypes.string,
};

export default withRouter(withTranslation()(SettingListContainer));
